import { render } from "./Overview.vue?vue&type=template&id=1d2597e4"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=1d2597e4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__